import React from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <p>Made with ❤️ by F3R</p>
    </footer>
  );
}

export default Footer;